var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass: "tag",
      class: { clickable: _vm.clickable },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
      },
    },
    [
      _vm.firstIcon
        ? _c("w-fa", { staticClass: "icon", attrs: { icon: _vm.firstIcon } })
        : _vm._e(),
      _vm._t("default"),
      _vm.icon
        ? _c("w-fa", { staticClass: "icon", attrs: { icon: _vm.icon } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }